/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { Box, CircularProgress, Grid } from '@material-ui/core';
import PageContainer from 'components/PageContainer';

import styles from './styles';
interface LoadingViewProps {
  headerTitle: string;
}

const LoadingPage: React.FC<LoadingViewProps> = props => {
  const { headerTitle } = props;
  return (
    <Box mt={8}>
      <Box mb={2}>
        <h1 css={styles.titleText}>{headerTitle}</h1>
      </Box>

      <PageContainer>
        <Grid container alignItems="center" justify="center">
          <Grid item>
            <Box my={5}>
              <CircularProgress aria-label="progress" size={24} />
            </Box>
          </Grid>
        </Grid>
      </PageContainer>
    </Box>
  );
};

export default LoadingPage;
